module.exports = __webpack_public_path__ + "@/assets/img/logo-visual-health-care.be0c45f6.png";